export default "__VITE_ASSET__850cab1e__"